import send from "../../util/request";

export function getOrderDomesticSelect(params = {}) {
  return send({ url: '/ipp/order-domestic/select', method: 'POST', data: params, options: { loading: true } });
}

export function getOrderDomesticDetail(params = {}) {
  return send({ url: '/ipp/admin/order-domestic/detail', method: 'POST', data: params });
}

export function orderDomesticSubmit(params = {}) {
  return send({ url: '/ipp/order-domestic/submit', method: 'POST', data: params });
}

export function orderDomesticCancel(params = {}) {
  return send({ url: '/ipp/order-domestic/cancel', method: 'POST', data: params });
}

export function orderDomesticInfo(params = {}) {
  return send({ url: '/ipp/order-domestic/info', method: 'POST', data: params });
}

export function orderDomesticSave(params = {}) {
  return send({ url: '/ipp/order-domestic/save', method: 'POST', data: params });
}

export function orderDomesticCompanyLists(params = {}) {
  return send({ url: '/ipp/order-domestic/company-lists', method: 'POST', data: params });
}

export function orderDomesticOrderInfo(params = {}) {
  return send({ url: '/ipp/order-domestic/order-info', method: 'POST', data: params });
}